import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { RootState } from "@/store/modules/general/types";
import { PEDIDO } from './types';



const namespaced = true;

type PedidoCompletadosModule = Module<PEDIDO, RootState>;

export const PedidoCompletados: PedidoCompletadosModule = {
    namespaced,
    actions,
    getters,
    mutations,
}